import React from "react";
import { ChevronDown } from "lucide-react";

interface PageSizeSelectProps {
  value: number;
  onChange: (value: number) => void;
  options?: number[];
  className?: string;
  /** Set to "" to hide the label. Defaults to "Rows per page". */
  label?: string;
}

const DEFAULT_OPTIONS = [10, 25, 50, 100];

/** Rows-per-page selector used above list/table pages. */
const PageSizeSelect: React.FC<PageSizeSelectProps> = ({
  value,
  onChange,
  options = DEFAULT_OPTIONS,
  className = "",
  label = "Rows per page",
}) => {
  return (
    <div className={`flex items-center gap-2 ${className}`}>
      {label && (
        <span className="whitespace-nowrap text-sm text-gray-500 dark:text-gray-400">
          {label}
        </span>
      )}
      <div className="relative inline-block">
        <select
          value={value}
          onChange={(e) => onChange(Number(e.target.value))}
          aria-label={label || "Rows per page"}
          className="h-9 appearance-none rounded-full border border-gray-300 bg-white pl-4 pr-8 text-sm text-gray-700 outline-none focus:border-primary-500 dark:border-gray-700 dark:bg-gray-800 dark:text-gray-200"
        >
          {options.map((opt) => (
            <option key={opt} value={opt}>
              {opt}
            </option>
          ))}
        </select>
        <ChevronDown
          size={14}
          className="pointer-events-none absolute right-2.5 top-1/2 -translate-y-1/2 text-gray-400"
        />
      </div>
    </div>
  );
};

export default PageSizeSelect;
